// Table columns configuration
import { Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

const columns = [
  {
    title: "Lists Count",
    dataIndex: "lists_count",
    key: "lists_count",
    sorter: (a, b) => {
      // Extract the number from "X lists" format
      const numA = parseInt(a.lists_count.split(' ')[0]);
      const numB = parseInt(b.lists_count.split(' ')[0]);
      return numA - numB;
    }
  },
  {
    title: "Unique Person Count",
    dataIndex: "unique_person_count",
    key: "unique_person_count",
    sorter: (a, b) => a.unique_person_count - b.unique_person_count
  },
  {
    title: "Download",
    key: "download",
    render: (_, record) => (
      <Button
        type="primary"
        size="small"
        icon={<DownloadOutlined />}
        onClick={(e) => {
          e.stopPropagation();
          if (record.onDownload) {
            record.onDownload(record.list_count_value);
          }
        }}
      >
        Download
      </Button>
    )
  }
];

export default columns;
